import React from "react";

const Terms_Conditions = () => {
  return (
    <div className="Associate__container">
      <div className="box">
        <h1> Terms and Conditions</h1>
        <h3>Welcome to Coinstorey!</h3>
        <p>
          These terms and conditions regulate your use of Coinstorey Website,and
          Coinstorey’s mobile application (together, "Coinstorey"), and form a
          binding legal contract between Hansis IT Supervision Pvt. Ltd (the
          owner and operator of Coinstorey) and you. By accessing Coinstorey,
          you hereby accept these Terms and Conditions, Privacy Policy and any
          other disclaimers or terms made available on Coinstorey, as may be
          amended from time to time. Do not continue to use Coinstorey if you do
          not agree to all of such Terms and Conditions, and Privacy Policy and
          disclaimers and terms on Coinstorey.
        </p>
        <p>
          The following terminology applies to these Terms and Conditions and
          Privacy Policy, unless the context requires otherwise: "Client",
          "User" "you" and "your" refers to, any person that uses, accesses,
          links to, or refers to Coinstorey or the Company. "The Company",
          "ourselves", "we", "our" and "us", refers to Hansis IT Supervision
          Pvt. Ltd. "Party" or "Parties" refers to both the Client and
          ourselves. Any use of the above terminology or other words in the
          singular, plural, capitalization and/or he/she or they, shall be taken
          as interchangeable.
        </p>
        <p>
          We reserve the right to modify these Terms and Conditions, Privacy
          Policy and disclaimers and terms related to services we provide
          ("Coinstorey Services") at any time by posting the same on Coinstorey.
          We may, at our sole discretion, also notify you of any change or
          modification in these Terms and Conditions, Privacy Policy, and other
          terms and disclaimers referred to herein or provided by us, by way of
          sending an email to your registered email address or posting
          notifications in your Coinstorey account on Coinstorey. You may then
          exercise the options provided in such an email or notification to
          indicate non-acceptance of the modified Terms and Conditions, Privacy
          Policy, and other terms and disclaimers made available by us. If such
          options are not exercised by you within the time frame prescribed in
          the email or notification, you will be deemed to have accepted the
          modified Terms and Conditions, Privacy Policy, and other terms and
          disclaimers made available by us. Certain Coinstorey Services being
          provided on Coinstorey may be subject to additional rules and
          regulations. To the extent that these Terms and Conditions are
          inconsistent with the additional conditions set down, the additional
          conditions shall prevail.
        </p>
        <h2>What are Coinstorey Contests:</h2>
        To participate in a Coinstorey Contests (Public/Private Contest), you
        must have a valid email address. Only those Users who have successfully
        registered on Coinstorey in accordance with the procedure outlined below
        shall be eligible to participate in the Contest(s) and win prizes. In
        the event a User indicates that he/she is using or accessing Coinstorey
        from Assam, Odisha, Sikkim, Nagaland or Telangana, such User will not be
        permitted to proceed to sign up for the Contest and cannot participate
        in any paid version of the Contest(s). Persons below the age of eighteen
        (18) years are not allowed to participate on any of the Contests or
        games (by whatever name called) on Coinstorey and Users must disclose
        their real age at the time of getting access to Coinstorey. In a
        Contest, you will be awarded virtual money which you can use to select
        virtual currency and build a virtual portfolio, and compete with other
        Users to win prizes. There are daily, weekly and monthly Contests. The
        Contests are both free-to-play, i.e., a User does not have to pay any
        money to participate in such Contests, but may win real money prizes,
        and paid i.e., a User must pay an entry fee amount to participate in
        such Contests, and real-money prizes are awarded. In order to register
        for the Contest, you are required to:
        <ul>
          <li>Enter your name</li>
          <li>Enter your email address.</li>
          <li>Enter your mobile number.</li>
          <li>You will receive an OTP; please input that to move forward.</li>
          <li>Enter your 4-digit PIN to set up your account</li>
          <li>
            Confirm that you agree and shall abide by these Terms and Conditions
          </li>
        </ul>
        <h3>Types of Coinstorey Contests</h3>
        <h4>1.Private Contests:</h4>
        <ul>
          <li>
            You may participate in a private Contest, which is a closed,
            invite-only Contest.
          </li>
          <li>
            You may enter your virtual portfolio into such Contest upon
            receiving an invite to join the contest, and compete against the
            other Users who have been invited to join the Contest.
          </li>
          <li>
            The Host of room which has created the Contest can decide the number
            of players, entry fee, number of winners and the duration for which
            contest will be played.
          </li>
          <li>
            The winning amount is distributed to the players by the code written
            in the background based on the number of players entered, entry fee
            and number of winners.
          </li>
          <li>
            The winnings are paid out of the Users’ entry fee amounts, minus a
            fee charged by us on each entry fee, and such winnings and fees are
            subject to applicable taxes.
          </li>
          <li>
            Users pay the entry fee amount by way of regulated banking and
            payment channels only (i.e., licensed e-wallets, credit card / debit
            cards or BHIM UPI).
          </li>
          <li>
            Prizes are received by a User in their virtual account with us. From
            this account, the User may transfer the prize money to their
            e-wallets and bank accounts or use the value in the virtual account
            to pay for entry fees in other contests on Coinstorey.
          </li>
        </ul>
        <h4>2.Public Contests:</h4>
        <ul>
          <li>
            These Contests are open to all Users. Any User may join such
            Contests, unlike private contests, which are invite- only, as
            discussed above.
          </li>
          <li>
            These Contests are run by us directly. Except this difference, such
            Contests are governed by rules as are applicable to private
            contests.
          </li>
        </ul>
        <h2>Gameplay Rules</h2>
        <ul>
          <li>
            Coinstorey provides three sets of virtual portfolios which are free
            where users can do their virtual investment.
          </li>
          <li>
            Except for these three portfolios users can buy more portfolios for
            investment.
          </li>
          <li>
            In order to join a Contest user will have to make a portfolio for
            the contest and lock and pay the amount.
          </li>
          <li>
            Each user has to build a new portfolio each time while playing a new
            Contest to be eligible for getting a rank and an amount of 100000
            CST(virtual currency) is provided to each user for making their
            portfolio.
          </li>
          <li>
            If a user is joining a paid contest then the user must have the
            required amount present in their wallet.
          </li>
          <li>
            The User has the discretion on what coins(s) the User wants to add
            to a virtual portfolio which links to a Contest.
          </li>
          <li>
            For each Contests, Users will refer to and shall abide by the
            Contest rules.
          </li>
          <li>
            If a User exits a Contest that has started, he/she will not get a
            refund of their Entry fee.
          </li>
          <li>
            At the end of the affixed time period of a Contest (e.g., in a
            weekly Contest, at the end of the week), Users are ranked according
            to the value of their virtual portfolios relative to each other.
          </li>
          <li>
            The value of the virtual crypto currency depends upon the
            performance of their real-world counterparts in the Cryptocurrency
            market, but the distribution of prize money is not linked to such
            real-world prices.
          </li>
          <li>
            Similar to many competitions, predetermined amounts are awarded to
            designated ranks. For example, if the total prize money amount is
            INR 1,00,000(Rupees One Lakh) for a league, it may be distributed in
            a given ratio (e.g., 40:30:20:10:, amongst the top four players in a
            given league (i.e., Rank 1 gets INR 40,000 (Rupees Forty Thousand),
            Rank 2 gets INR 30,000 (Rupees Thirty Thousand) etc.).
          </li>
          <li>
            Therefore, even if all the Users get negative virtual returns on
            their virtual portfolios, the prizes are distributed according to
            which User has performed the best relative to others.
          </li>
        </ul>
        <h4>
          <u>
            Therefore, the value of the prizes awarded to winners does not
            correlate to the value of the actual Cryptocurrency in the
            Cryptocurrency market.
          </u>
        </h4>
        <p>
          Users who are winners of the Contests ("Winners") will be announced at
          the end of the contest. The prizes will be distributed in a ratio and
          manner pre-published by us, and disclosed to Coinstorey Users, on
          Coinstorey from time to time. Coinstorey shall not be liable to pay
          any prize if it is discovered that the Winner(s) have not abided by
          these Terms and Conditions and other rules and regulations in relation
          to the use of Coinstorey.
        </p>
        <p>
          Coinstorey is a game of skill as it involves judgment, strategy and
          multi-disciplinary knowledge, training, adherence to a virtual budget,
          and calculation and mathematics. The Supreme Court has recognized that
          games of skill are not gambling activities in various cases including
          State of Andhra Pradesh v. K Satyanarayana (AIR 1968 SC 825) and K.R.
          Lakshmanan v. State of Tamil Nadu (AIR 1996 SC 1153) where it held
          inter alia that games of skill would be those where "success depends
          principally upon the superior knowledge, training, attention,
          experience and adroitness of the player". By participating in the
          Contest and using Coinstorey, each User acknowledges and agrees that
          he/she is participating in a game of skill.
        </p>
        <h3>Usage Conditions </h3>
        <ul>
          <li>
            The Company, at its sole discretion, may disqualify any User from a
            Contest, refuse to award benefits or prizes and require the return
            of any prizes, if the User engages in unfair conduct, which the
            Company deems to be improper, unfair or otherwise adverse to the
            operation of Coinstorey or is in any way detrimental to other Users,
            which conduct includes, but is not limited to:
            <ul>
              <li>
                Falsifying ones’ own personal information (including, but not
                limited to, name, email address, bank account details and/or any
                other information or documentation as may be requested by
                Coinstorey to enter a Contest and/or claim a prize/winning;
              </li>
              <li>
                Engaging in any type of financial fraud or misrepresentation
                including unauthorized use of credit/debit instruments, payment
                wallet accounts etc. to enter a Contest or claim a prize. It is
                expressly clarified that the onus to prove otherwise shall
                solely lie on the User;
              </li>
              <li>
                Colluding with any other User(s) or engaging in any type of
                syndicate play;
              </li>
              <li>
                Any violation of Contest rules or the Terms of Use, Privacy
                Policy, or other disclaimers or terms that we make available;
              </li>
            </ul>
          </li>
          <li>
            Accumulating points or prizes through unauthorized methods such as
            automated bots, or other automated means;
          </li>
          <li>
            Using automated means (including but not limited to harvesting bots,
            robots, parser, spiders or screen scrapers) to obtain, collect or
            access any information on Coinstorey or of any User for any purpose
          </li>
          <li>
            Tampering with the administration of a Coinsorey or trying to in any
            way tamper with the computer programs or any security measure
            associated with Coinstorey;
          </li>
          <li>
            Obtaining other Users’ information without their express consent
            and/or knowledge and/or spamming other Users (spamming may include
            but shall not be limited to send unsolicited emails to Users,
            sending bulk emails to Coinstorey Users, sending unwarranted email
            content either to selected Users or in bulk); or
          </li>
          <li>
            Abusing Coinstorey in any way including making obscene, offensive or
            illegal contents.
          </li>
        </ul>
        <h3>You shall not:</h3>
        <ul>
          <li>
            use Coinstorey for any purpose that is unlawful, illegal or
            forbidden by law;
          </li>
          <li>
            play any paid Contests if you reside in a Restricted State, and you
            are solely responsible for evaluating and assessing the law in your
            respective State’s jurisdiction;
          </li>
          <li>
            use Coinstorey in any manner that harms Gamesapp or its directors,
            employees, affiliates, distributors, partners, service providers,
            and / or any other User;
          </li>
          <li>
            remove any copyright and other proprietary notices contained in any
            content on Coinstorey;
          </li>
          <li>
            copy, decompile, recompile, assemble, disassemble, reverse engineer,
            or otherwise attempt to discover any source code, sell, assign or
            otherwise transfer any intellectual property in Coinstorey;
          </li>
          <li>
            modify, rent, lease, loan, sell, assign, distribute, grant a
            security interest in, or otherwise transfer any right to the
            technology or software underlying Coinstorey or Coinstorey Services;
          </li>
          <li>
            participate in the transfer or sale, rent or sub-license of material
            from Coinstorey;
          </li>
          <li>
            send communications containing unsolicited / unauthorized
            advertisements, promotions or marketing material;
          </li>
          <li>create derivative works of material from Coinstorey;</li>
          <li>
            redistribute, publicly perform or publicly display content from
            Coinstorey or in any way exploit any of the materials or content on
            Coinstorey either in whole or in part without express written
            license from Coinstorey;
          </li>
          <li>
            transmit files that contain viruses, corrupted files, or any other
            similar software or programs that may damage or adversely affect the
            operation of another person's computer, Coinstorey, any software,
            hardware, or telecommunications equipment;
          </li>
          <li>
            advertise, offer or sell any goods or services for any commercial
            purpose on Coinstorey without the express written consent of
            Coinstorey;
          </li>
          <li>
            falsify or delete any author attributions, legal or other proper
            notices or proprietary designations or labels of the origin or the
            source of software or other material;
          </li>
          <li>
            collect or store personal information about other Users except as
            permitted by applicable law;
          </li>
          <li>
            impersonate any person or entity, including, but not limited to, an
            ambassador of Coinstorey, or falsely state or otherwise misrepresent
            User's affiliation with a person or entity;
          </li>
          <li>
            forge headers or manipulate identifiers or other data in order to
            disguise the origin of any content transmitted through Coinstorey or
            to manipulate User's presence on Coinstorey(s);
          </li>
          <li>
            take any action that imposes an unreasonably or disproportionately
            large load on our infrastructure;
          </li>
          <li>
            disrupt, overburden, or aid or assist in the disruption or
            overburdening of (1) any computer or server used to offer or support
            Coinstorey or the CoinStorey Services; or (2) the enjoyment of
            Coinstorey Services by any other User or person.
          </li>
          <li>
            institute, assist or become involved in any type of attack,
            including without limitation to distribution of a virus, denial of
            service, or other attempts to disrupt Coinstorey Services or any
            other person's use or enjoyment of Coinstorey Services.{" "}
          </li>
          <li>
            gain unauthorised access to the User accounts, servers or networks
            connected to Coinstorey Services by any means other than the user
            interface provided by Coinstorey, including but not limited to, by
            circumventing or modifying, attempting to circumvent or modify, or
            encouraging or assisting any other person to circumvent or modify,
            any security, technology, device, or software that underlies or is
            part of Coinstorey Services. You agree not to use any automated
            means, including, without limitation, agents, robots, scripts, or
            spiders, to access, monitor, or copy any part of our sites;
          </li>
          <li>
            use cheats, exploits, automation, software, bots, hacks or any
            unauthorized third-party software designed to modify or interfere
            with Coinstorey Services and/or Coinstorey experience or assist in
            such activity;
          </li>
          <li>
            display or use names, logos, marks, labels, trademarks, copyrights
            or intellectual and proprietary rights of any third party on
            Coinstorey;
          </li>{" "}
          or,
          <li>
            violate applicable laws or third party rights in any manner
            whatsoever if such violation involves Coinstorey or its Users.
          </li>
        </ul>
        <p>
          Without prejudice to the generality of the foregoing, any Users
          sharing any material or information on securities are responsible for
          their own legal compliance, and you hereby agree that wherever
          applicable, you have obtained the relevant securities law
          registrations, including but not limited to registration as an
          investment adviser, research analyst, or portfolio manager. Coinstorey
          bears no responsibility and disclaims all liability in this regard for
          any non-compliance by Users of applicable law.
        </p>
        <br />
        <p>
          You agree to provide true, accurate, current and complete information
          at the time of registration and at all other times (as required by
          us). You further agree to update and keep updated your registration
          information. You shall not register or operate more than one User
          account with Coinstorey.
        </p>
        <br />
        <p>
          If a User chooses a username that, in Coinstorey's considered opinion
          is obscene, indecent, abusive or that might subject Coinstorey to
          public disparagement or scorn, we reserve the right, without prior
          notice to the User, to restrict usage of such names, which in our
          opinion fall within any of the said categories and/or change such
          username and intimate the User or delete such username and posts from
          Coinstorey, deny such User access to Coinstorey, or any combination of
          these options.
        </p>
        <br />
        <p>
          Any password issued by Coinstorey to a User may not be revealed to
          anyone else. Users may not use anyone else's password. Users are
          responsible for maintaining the confidentiality of their accounts and
          passwords. Users agree to immediately notify Coinstorey of any
          unauthorized use of their passwords or accounts or any other breach of
          security. Users agree to exit/log-out of their accounts at the end of
          each session. Coinstorey shall not be responsible for any loss or
          damage that may result to the User if the User fails to comply with
          these requirements or otherwise loses control of their Coinstorey
          account.
        </p>
        <br />
        <p>
          We may offer chat features, messaging groups, and other means of
          social interaction to enable communication between Users. Our role is
          limited to providing the Coinstorey Services. With respect to User
          content and communication between Users, our role is that of an
          ‘intermediary’ as defined under the Information Technology Act, 2000
          and the rules thereunder. Being an intermediary, we have no
          responsibility and / or liability in respect of any User content on
          the App and you are solely responsible therefore. As an ‘intermediary’
          under the Information Technology Act, 2000, for the purpose of content
          posted by Users, we do not pre-screen User content or communications
          between Users. We have no obligation to monitor any User content apart
          from our obligations as an ‘intermediary’ under the said Act.
        </p>
        <br />
        <p>
          When you use Coinstorey, you specifically undertake not to host,
          display, upload, modify, publish, transmit, update or share any
          content that:
        </p>
        <ul>
          <li>Belongs to another person and to which you have no right;</li>
          <li>
            Is grossly harmful, harassing, blasphemous, defamatory, obscene,
            pornographic, paedophilic, libellous, invasive of another’s privacy,
            hateful, or racially, ethnically objectionable, disparaging,
            relating or encouraging money laundering or gambling, or otherwise
            unlawful in any manner whatsoever;
          </li>
          <li>Harms minors in anyway</li>
          <li>
            Infringes any patent, trademark, copyright, or other proprietary
            rights
          </li>
          <li>Violates any applicable laws</li>
          <li>
            Deceives or misleads the addressee about the origin of such messages
            or communicates any information that is grossly offensive or
            menacing in nature
          </li>
          <li>Impersonates another person</li>
          <li>
            Contains software viruses or any other computer code, files, or
            programs designed to interrupt, destroy, or limit the functionality
            of any computer resource; or
          </li>
          <li>
            Threatens the unity, integrity, defence, security, or sovereignty of
            India, friendly relations with foreign states, or public order or
            causes incitement to the commission of any cognizable offence or
            prevents investigation of any offence or is insulting any other
            nation.
          </li>
        </ul>
        You hereby warrant and represent that:
        <ul>
          <li>
            You are solely responsible for content that you may upload, post,
            e-mail, transmit, or otherwise make available on Coinstorey;
          </li>
          <li>
            You have all necessary permissions and entitlements under applicable
            law and from third parties to post content on our website and have
            all necessary licenses and consents to do so;
          </li>
          <li>
            No part of any content you make available on Coinstorey infringes
            any intellectual property right, including without limitation
            copyright, patent or trademark of any third party;
          </li>
          <li>
            You have all regulatory licenses, approvals and permissions as
            required by applicable law for your use of Coinstorey, including but
            not limited to any necessary licenses, approvals and permissions by
            the Securities and Exchange Board of India.
          </li>
        </ul>
        <p>
          If we suspect any illegal, wrongful or fraudulent activity on
          Coinstorey by any User, notwithstanding any other rights we may have,
          we reserve the right to inform the relevant government or law
          enforcement authorities. We will cooperate in all investigative
          procedures or requests for access / information initiated by any such
          government or law enforcement authorities. We are not under any
          obligation to act on any communications, requests and suggestions from
          Users or the general public or to respond to any one. Our decision in
          this respect shall be final. Specifically, if any such request relates
          to a request / demand to take down/ disable/ remove/ delete any User
          content or Coinstorey content, we are under no legal obligation to
          respond to or act on such requests. We will take such action as we are
          required to take under applicable law. If there is any valid court
          order or administrative order issued requiring us to take any action,
          then we will comply with such court order or administrative order.
        </p>
        <br />
        <p>
          In the event any User breaches, or the Company reasonably believes
          that such User has breached these Terms and Conditions, or has
          illegally or improperly used Coinstorey, the Company may, at its sole
          and absolute discretion, and without any notice to the User, restrict,
          suspend or terminate such User's access to all or any part of
          Coinstorey, deactivate or delete the User's account and all related
          information on the account, delete any content posted by the User on
          Coinstorey and further, take technical and legal steps as it deems
          necessary. It is clarified that in case you are found to be in
          violation of the aforementioned terms, Coinstorey reserves its right
          to initiate appropriate civil/criminal remedies as it may be advised,
          in addition to forfeiture and/or recovery of prize money if any.
        </p>
        <p>
          <b>
            At any time and for any reason, and subject to applicable law,
            Coinstorey may, at its sole and absolute discretion:
          </b>
        </p>
        <ul>
          <li>
            Restrict, suspend, or terminate any User's access to all or any part
            of Coinstorey or Coin Services;
          </li>
          <li>
            Change, suspend, or discontinue all or any part of the Coinstorey
            Services;
          </li>
          <li>
            Reject, move, or remove any material that may be submitted by a
            User;
          </li>
          <li>Move or remove any content that is available on Coinstorey;</li>
          <li>
            Deactivate or delete a User's account and all related information
            and files on the account;
          </li>
          <li>
            Establish general practices and limits concerning use of Coinstorey;
          </li>
          <li>
            Assign its rights and liabilities to all User accounts hereunder to
            any entity.
          </li>
        </ul>
        <h3>Community Policies</h3>
        <h4>
          <u>Hate Speech</u>
        </h4>
        <p>
          You are not allowed to promote violence against or directly attack or
          threaten other Coinstorey users on the basis of race, ethnicity,
          national origin, caste, sexual orientation, gender, gender identity,
          religious affiliation, age, disability, or serious disease. Users
          inciting harm towards others on the basis of these categories would be
          suspended.
        </p>
        <h4>
          <u>Obscene Display Names and Hateful Imagery</u>
        </h4>
        <p>
          You cannot use your username, display name, or profile bio to engage
          in abusive behavior, such as targeted harassment or expressing hate
          towards a person, group, or protected category. You may not use
          hateful images or symbols in your profile image or profile header.
        </p>
        <h4>
          <u>Harassment and Bullying</u>
        </h4>
        <p>
          Using abusive language, sharing others’ personal or sensitive
          information or inciting or engaging others to do any of the same is
          not allowed.
        </p>
        <h4>
          <u>Promoting Violence</u>
        </h4>
        <p>
          Threatening or inciting violence of any kind is strictly prohibited.
          We don’t allow individuals or groups that engage in or promote
          violence, or organized criminal activity to use Coinstorey to conduct
          such activities.
        </p>
        <h4>Engaging in Spam or Scam</h4>
        <p>
          You are not allowed to share messages in Social groups or to
          Individual users that are untargeted, irrelevant, obviously unwanted,
          unauthorized, inappropriately commercial or promotional, or
          gratuitously repetitive messages or other similar content. Do not use
          Coinstorey to capitalize or sensationalize on tragic events for
          commercial purposes. Do not use our invitation feature to send
          promotional messages to people you don’t know or to otherwise spam
          people. Any player found engaging in Community policies Violation will
          be barred from the platform and account will be suspended.
        </p>
        <h4>Fair play policy</h4>
        <ul>
          <li>
            One Beneficiary Bank/Wallet account can be linked to utmost 4
            Coinstorey accounts
          </li>
          <li>
            Maximum of 2 accounts can be registered and used on one device. If a
            user wants to de-link them, he/she can drop a request to
            info@coinstorey.com about the same
          </li>
          <li>
            Use "Invite Friends" program to refer and recommend only upto 10
            friends and relatives in a week to get Coinstorey Bonus.
          </li>
        </ul>
        <br />
        <p>
          Any player found engaging in Fair Play policy Violation will be barred
          from the platform and account will be suspended.
        </p>
        <br />
        <p>
          By registering and playing on our platform, you agree that you will
          ensure fair play and will not engage in any Fair Play Violation by
          technical or non-technical means to manipulate the game outcomes.
        </p>
        <br />
        <p>
          Genuine users who want to submit an appeal have to submit the
          following details in the email
        </p>
        <ul>
          <li>Registered phone number</li>
          <li>Any government approved "Photo Id"</li>
          <li>
            Bank account details like Cancelled cheque/ UPI ID from Google-Pay
            or Bank App/ Wallet info
          </li>
        </ul>
        <br />
        <p>
          Accounts of genuine users affected by Fair Play Policy violation, will
          be reactivated after review and confirmation by our risk management
          team.
        </p>
        <h4>Commercial Communication</h4>
        <p>
          Users consent to receiving communications such as announcements,
          administrative messages and advertisements from us or any of our
          partners, licensors or associates. You agree to ensure that you can
          receive all communication from Coinsorey by marking e-mails or sending
          SMSs from Coinstorey as part of your "safe senders" list or other
          similar category. Coinstorey shall not be held liable if any e-mail,
          SMS or other message remains unread by a User as a result of such
          message getting delivered to the User's junk or spam folder or similar
          category.
        </p>
        <h4>Cookies</h4>
        <p>
          <ul>
            <li>
              We employ the use of cookies. By accessing Coinstorey, you agreed
              to use cookies in agreement with our Privacy Policy.
            </li>
            <li>
              Most interactive websites use cookies to let us retrieve the
              User's details for each visit. Cookies are used by our website to
              enable the functionality of certain areas to make it easier for
              people visiting our website. Some of our affiliate/advertising
              partners may also use cookies.
            </li>
          </ul>
        </p>
        <h4>License</h4>
        <ul>
          <li>
            Coinstorey includes a combination of content created by Coinstorey,
            its licensors and/or you.
          </li>
          <li>
            Unless otherwise stated, the intellectual property rights in all
            software underlying Coinstorey and the Coinstorey Services and
            material published on Coinstorey, including (but not limited to)
            Contests, software, written content, photographs, graphics, images,
            illustrations, marks, logos, audio or video clippings and Flash
            animation, are owned by Coinstorey and/or its licensors, as
            applicable. All intellectual property rights are reserved. You may
            access this from Coinstorey for your own personal use subject to
            restrictions set in these terms and conditions. You hereby grant
            Coinstorey and its affiliates, partners, licensors and associates a
            worldwide, irrevocable, royalty-free, non-exclusive, sub-licensable
            license to use, reproduce, edit and authorize others to use,
            reproduce, edit, create derivative works of, distribute, publicly
            perform, publicly display, transfer, transmit, and/or publish any of
            the content you make available on Coinstorey in any and all forms,
            formats or media and for any of the following purposes:
            <ul>
              <li>displaying such content on Coinstorey</li>
              <li>
                distributing such content, either electronically or via other
                media, to other Users seeking to download or otherwise acquire
                it, and/or
              </li>
              <li>
                storage of such content in any form, medium, or technology.
              </li>{" "}
            </ul>
          </li>
        </ul>
        <p>
          All names, logos, marks, labels, trademarks, copyrights or
          intellectual and proprietary rights on Coinstorey belonging to any
          person (including User), entity or third party are recognized as
          proprietary to the respective owners and any claims, controversy or
          issues against these names, logos, marks, labels, trademarks,
          copyrights or intellectual and proprietary rights must be directly
          addressed to the respective parties under notice to Coinstorey.
        </p>
        <h4>Indemnity</h4>
        <p>
          You agree to indemnify and hold harmless the Company, its directors,
          employees, affiliates and assigns against all costs, damages, loss and
          harm including towards litigation costs and counsel fees, in respect
          of:
        </p>
        <ul>
          <li>
            any breach by you of these Terms and Conditions or any other rules,
            regulations, disclaimers or conditions on Coinstorey;
          </li>
          <li>
            any third party claims that may be initiated including for
            infringement of intellectual property rights arising out of your
            actions or omissions; and
          </li>
          <li>any act of fraud or negligence by you.</li>
        </ul>
        <h4>Payment Terms</h4>
        <p>
          In respect of any transactions entered into on Coinstorey, including
          making a payment to participate in the paid versions of Contest(s),
          Users agree to be bound by the following payment terms:
        </p>
        <p>
          The payment of the pre-designated amount Users make to participate in
          the Contest(s) is inclusive of the pre-designated entry fee for access
          to the Contest Services charged by Coinstoey and pre-determined
          participant’s contribution towards the prize money pool which will
          eventually be paid to Winners.
        </p>
        <p>
          Coinstorey reserves the right to charge an entry fee, which would be
          specified and notified by Coinstoey on the Contest page, being created
          on Coinstoey, prior to a User's joining of such Contest. The User may
          participate in a Contest wherein the User has to contribute a
          pre-specified contribution towards the prize money pool of such
          Contest, which will be passed on to the Winner(s) of the Contest after
          the completion of the Contest as per the terms and conditions of the
          Contest. The User acknowledges that subject to time taken for bank
          reconciliations and such other external dependencies that Coinstorey
          has on third parties, any transactions on Coinstoey may take up to 7
          working days to be processed. The Company merely acts as a duly
          appointed agent of the User to whom the payment is due, and does not
          operate a payment system. You hereby duly appoint the Company as your
          agent for this purpose. A transaction, once confirmed, is final and no
          cancellation is permissible.
        </p>
        <p>
          Coinstorey may, in certain exceptional circumstances and at its sole
          and absolute discretion, refund the amount to the User after deducting
          applicable cancellation charges and taxes. At the time of the
          transaction, Users may also be required to take note of certain
          additional terms and conditions and such additional terms and
          conditions shall also govern the transaction. To the extent that the
          additional terms and conditions contain any clause that is conflicting
          with the present terms and conditions, the additional terms and
          conditions shall prevail.
        </p>
        <h4>Hyperlinking to our Content</h4>
        <p>
          The following organizations may link to Coinstorey without prior
          written approval:
        </p>
        <ul>
          <li>Government agencies;</li>
          <li>Search engines;</li>
          <li>News organizations;</li>
        </ul>
        <p>
          Online directory distributors may link to our website in the same
          manner as they hyperlink to the Websites of other listed businesses.
          These organizations may link to our home page, to publications or to
          other Website information so long as the link:
        </p>
        <ul>
          <li>is not in any way deceptive;</li>
          <li>
            does not falsely imply sponsorship, endorsement or approval of the
            linking party and its products and/or services; and
          </li>
          <li>fits within the context of the linking party's site.</li>
        </ul>
        <p>
          <b>
            We may consider and approve other link requests from the following
            types of organizations:
          </b>
        </p>
        <ul>
          <li>commonly-known consumer and/or business information sources;</li>
          <li>associations or other groups representing charities;</li>
          <li>online directory distributors;</li>
          <li>internet portals;</li>
          <li>accounting, law and consulting firms; </li>
          <li>educational institutions and trade associations; and</li>
          <li>any other third party.</li>
        </ul>
        <p>
          <b>
            We will approve link requests from these organizations if we decide
            that:
          </b>
        </p>
        <ul>
          <li>
            the link would not make us look unfavorably to ourselves or to our
            accredited businesses;
          </li>
          <li>the organization does not have any negative records with us;</li>
          <li>
            the benefit to us from the visibility of the hyperlink compensates
            the absence of the Company; and
          </li>
          <li>
            the link is in the context of general resource information. Such
            organizations which are interested in linking to our website must
            inform us by sending an e-mail to the Company. Please include your
            name, your organization name, contact information as well as the URL
            of your site, a list of any URLs from which you intend to link to
            our website, and a list of the URLs on our site to which you would
            like to link.
          </li>
        </ul>
        <p>
          <b>Approved organizations may hyperlink to our Website as follows:</b>
        </p>
        <ul>
          <li>By use of our corporate name; or</li>
          <li>
            By use of the uniform resource locator (URL) being linked to; or
          </li>
          <li>
            By use of any other description of Coinstorey being linked to that
            makes sense within the context and format of content on the linking
            party's site.
          </li>
        </ul>
        <p>
          <b>
            No use of Coinstorey's logo or other artwork will be allowed for
            linking absent a trademark license agreement.
          </b>
        </p>
        <p>
          <b>iFrames</b>
        </p>
        <p>
          Without prior approval and written permission, you may not create
          frames around Coinstorey that alter in any way the visual presentation
          or appearance of Coinstorey.
        </p>
        <p>
          <b>Content Liability</b>
        </p>
        <p>
          If any third party is linking to Coinstorey from its website or mobile
          application, we shall not be held responsible for any content that
          appears on its website or mobile application. You and such third
          parties agree to protect and defend us against all claims that is
          rising on such website or mobile application. No link(s) to Coinstorey
          should appear on any website or mobile application that may be
          interpreted as libelous, obscene, illegal, or criminal, or which
          infringes, otherwise violates, or advocates the infringement or other
          violation of, any third party rights.
        </p>
        <p>
          <b>Reservation of Rights</b>
        </p>
        <p>
          We reserve the right to request that you remove all links or any
          particular link to our Coinstorey. You agree to immediately remove all
          links to Coinstorey upon request. We also reserve the right to amend
          these terms and conditions and it's linking policy at any time. By
          linking to Coinstorey, you agree to be bound to and follow these
          linking terms and conditions.
        </p>
        <p>
          <b>Removal of links from our website</b>
        </p>
        <p>
          If you find any link on our Website that is offensive for any reason,
          you are free to contact and inform us any moment. Subject to
          applicable law, we will consider requests to remove links but we are
          not obligated to or so or to respond to you directly.
        </p>
        <p>
          We do not ensure that the information on this website is correct, we
          do not warrant its completeness or accuracy; nor do we promise to
          ensure that the website remains available or that the material on the
          website is kept up to date.
        </p>
        <h4>Disclaimer and Limitation of Liability</h4>
        <p>
          To the maximum extent permitted by applicable law, we exclude all any
          liability, including but not limited to liability arising out of
          representations, warranties, and conditions, relating to Coinstorey
          and the use of Coinstorey Services. Nothing in this disclaimer will:
        </p>
        <ul>
          <li>
            limit or exclude our or your liability for death or personal injury;
          </li>
          <li>
            limit or exclude our or your liability for fraud or fraudulent
            misrepresentation;
          </li>
          <li>
            limit any of our or your liabilities in any way that is not
            permitted under applicable law; or
          </li>
          <li>
            exclude any of our or your liabilities that may not be excluded
            under applicable law.
          </li>
        </ul>
        <p>
          As long as Coinstorey and the information and services on Coinstorey
          are provided free of charge, we will not be liable for any loss or
          damage of any nature. Users access the Coinstorey Services provided on
          Coinstorey voluntarily and at their own risk and Coinstorey is
          provided on an "as-is" basis without express or implied warranties of
          any nature.
        </p>
        <p>
          We accept no liability, whether jointly or severally, for any errors
          or omissions, whether on behalf of ourselves or third parties, in
          relation to the prizes. Users shall be solely responsible for any
          consequences which may arise due to their access of Coinstorey
          Services by conducting an illegal act or due to non-conformity with
          these Terms and Conditions and other rules and regulations in relation
          to Coinstorey Services, including provision of incorrect address or
          other personal details. Users also undertake to indemnify us and our
          respective officers, directors, employees and agents on the happening
          of such an event (including without limitation cost of attorney, legal
          charges etc.) on full indemnity basis for any loss/damage suffered by
          us on account of such act on the part of the Users. In no event shall
          the Company be liable to any User for acts or omissions arising out of
          or related to User's engagement with Coinstorey or his/her
          participation in Coinstorey or any Contests.
        </p>
        <p>
          In consideration of the Company allowing Users to access the
          Coinstorey Services, to the maximum extent permitted by law, Users
          waive and release each and every right or claim, all actions, causes
          of actions (present or future) each of them has or may have against
          the Company, its respective agents, directors, officers, business
          associates, group companies, sponsors, employees, or representatives
          for all and any injuries, accidents, or mishaps (whether known or
          unknown) or (whether anticipated or unanticipated) arising out of the
          provision of Coinstorey Services or related to the Contests or the
          prizes associated therewith.
        </p>
        <h4>Taxes Payable</h4>
        <p>
          All prizes shall be subject to deduction of tax ("TDS") as per the
          Income Tax Act 1961 as well as applicable indirect taxes including
          goods and services taxes. TDS will be deducted by the Company in
          accordance with the then current prescribed TDS rate. The Winners
          shall be responsible for payment of any other applicable tax,
          including but not limited to, income tax, gift tax, etc. in respect of
          the prize money. The decision of the Company with respect to the
          awarding of prizes shall be final, binding and non-contestable. The
          Company may, at its sole and absolute discretion, vary or modify the
          prizes being offered to Winners. Users shall not raise any claim
          against the Company or question its right to modify such prizes being
          offered, prior to closure of any Contest.
        </p>
        <h4>Dispute and Dispute Resolution</h4>
        <p>
          These Terms of Service shall be governed and construed in accordance
          with the laws of India.
        </p>
        <p>
          In the event of any and all disputes arising out of, or in connection
          with, these Terms of Service, the construction, validity,
          interpretation and enforceability of these Terms and Conditions, or
          the rights and obligations of the User(s) or Coinstorey, the party
          raising the dispute shall provide a written notification to the other
          party. On receipt of the written notification, the parties shall first
          try to resolve the dispute through discussions. In the event that the
          parties are unable to resolve the dispute within fifteen (15) days of
          receipt of notification, the dispute shall be settled by arbitration.
        </p>
        <p>
          The place, venue and seat of arbitration shall be Bengaluru, India.
          All arbitration proceedings shall be conducted in English and by a
          sole arbitrator in accordance with the provisions of the Arbitration
          and Conciliation Act, 1996, as amended from time to time, read with
          the rules of the Mumbai Centre for International Arbitration.
        </p>
        <p>
          The arbitration award will be final and binding on the Parties, and
          each Party will bear its own costs of arbitration and equally share
          the fees of the arbitrator unless the arbitral tribunal decides
          otherwise. The arbitrator shall be entitled to pass interim orders and
          awards, including the orders for specific performance and such orders
          would be enforceable in competent courts. The arbitrator shall give a
          reasoned award.
        </p>
        <p>
          Nothing contained in these Terms and Conditions shall prevent
          Coinstorey from seeking and obtaining interim or permanent equitable
          or injunctive relief, or any other relief available to safeguard
          Coinstorey's interest prior to, during or following the filing of
          arbitration proceedings or pending the execution of a decision or
          award in connection with any arbitration proceedings from a court
          having jurisdiction to grant the same. The pursuit of equitable or
          injunctive relief shall not constitute a waiver on the part of
          Coinstorey to pursue any remedy for monetary damages through the
          arbitration described herein.
        </p>
      </div>
    </div>
  );
};

export default Terms_Conditions;
